import React from 'react';
import './VirtualTours.css';

function VirtualTours() {
  return (
    <div className="virtual-tours-page">
      {/* Hero Section */}
      <section className="vt-hero">
        <div className="vt-hero-content">
          <h1 className="vt-title">MAKE YOUR PROPERTY <span className="vt-highlight">STAND OUT</span> ONLINE! 🚀</h1>
          <p className="vt-subtitle">
            Give buyers, renters, and guests the ability to explore your property from anywhere with an interactive 360° virtual tour from ThrillArts!
          </p>
          <a href="#book-now" className="vt-cta-button">Schedule a Shoot</a>
        </div>
      </section>

      {/* Perfect For Section */}
      <section className="vt-section vt-perfect-for">
        <h2 className="vt-section-title">Perfect For</h2>
        <div className="vt-grid">
          <div className="vt-card">
            <span className="vt-icon">🏡</span>
            <h3>Homes for Sale</h3>
            <p>Attract more buyers and reduce unnecessary showings with a 24/7 virtual open house.</p>
          </div>
          <div className="vt-card">
            <span className="vt-icon">🏢</span>
            <h3>Apartment Communities</h3>
            <p>Showcase amenities and units to prospective tenants anywhere in the world.</p>
          </div>
          <div className="vt-card">
            <span className="vt-icon">🏖️</span>
            <h3>Airbnb & Vacation Rentals</h3>
            <p>Increase bookings by letting guests step inside before they arrive.</p>
          </div>
          <div className="vt-card">
            <span className="vt-icon">🎉</span>
            <h3>Event Venues</h3>
            <p>Help planners visualize their next big event in your space.</p>
          </div>
          <div className="vt-card">
            <span className="vt-icon">🏬</span>
            <h3>Commercial Properties</h3>
            <p>Give investors and businesses a clear look at retail or office spaces.</p>
          </div>
          <div className="vt-card">
            <span className="vt-icon">👔</span>
            <h3>Property Managers</h3>
            <p>Enhance your listings and provide a premium experience for clients.</p>
          </div>
        </div>
      </section>

      {/* Services Section */}
      <section className="vt-section vt-services">
        <h2 className="vt-section-title">Available Services</h2>
        <div className="vt-services-list">
          <div className="vt-service-item">📸 Interactive room-to-room 360° tours</div>
          <div className="vt-service-item">🚁 Drone photos and aerial video</div>
          <div className="vt-service-item">🎥 Property promotional videos</div>
          <div className="vt-service-item">📸 Interior and exterior photography</div>
          <div className="vt-service-item">📱 Social-media reels</div>
          <div className="vt-service-item">🔗 Shareable tour links</div>
          <div className="vt-service-item">📲 QR codes for signs and flyers</div>
          <div className="vt-service-item">🔒 Private or public tours</div>
        </div>
      </section>

      {/* Demos Section */}
      <section className="vt-section vt-demos">
        <h2 className="vt-section-title">View Our Demos</h2>
        <div className="vt-demo-container">
          <div className="vt-demo">
            <h3>Property Demo</h3>
            <div className="vt-iframe-wrapper">
              <iframe
                src="https://pano.cool/p/01KPZZV6BA8E3SKNJWQD6JVV3S?s=Y3L5Q4&h=3.1&v=43.8&f=86.8"
                title="Property Demo"
                allowFullScreen
              ></iframe>
            </div>
            <a href="https://pano.cool/p/01KPZZV6BA8E3SKNJWQD6JVV3S?s=Y3L5Q4&h=3.1&v=43.8&f=86.8" target="_blank" rel="noreferrer" className="vt-link">Open in New Tab</a>
          </div>
          <div className="vt-demo">
            <h3>Apartment Demo</h3>
            <div className="vt-iframe-wrapper">
              <iframe
                src="https://pano.cool/p/01JHK1JR9BKCAJKENRS7HSYA8C"
                title="Apartment Demo"
                allowFullScreen
              ></iframe>
            </div>
            <a href="https://pano.cool/p/01JHK1JR9BKCAJKENRS7HSYA8C" target="_blank" rel="noreferrer" className="vt-link">Open in New Tab</a>
          </div>
        </div>
      </section>

      {/* Pricing & Booking Section */}
      <section id="book-now" className="vt-section vt-booking">
        <div className="vt-booking-card">
          <h2>Ready to Grab Attention?</h2>
          <p className="vt-price-range">Packages range from <strong>$250 – $1,200</strong></p>
          <p className="vt-intro-offer">Introductory packages are available for local agents, Airbnb hosts, apartment communities, and property managers.</p>
          <p className="vt-booking-desc">Let’s create a property experience that generates more interest and lets customers step inside before they arrive.</p>

          <div className="vt-contact-methods">
            <a href="tel:404-914-6066" className="vt-contact-btn">📞 Call or Text Us</a>
            <a href="/contact-us" className="vt-contact-btn vt-secondary-btn">✉️ Message Us</a>
          </div>
          <p className="vt-disclaimer">Message today to schedule your property shoot!</p>
        </div>
      </section>
    </div>
  );
}

export default VirtualTours;
